export const merSETASDI = 'merSETASDI';
export const CategoryInterventions = merSETASDI + '/CategoryInterventions';

export const merSETASDITrainer = merSETASDI + '/Trainer';
export const merSETASDITrainerSearch = merSETASDITrainer + '/Search';
export const UnassignedTrainers = merSETASDITrainer + '/Unassigned';